module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "detail-file"
    }
  }, [_c('x-table', {
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "cell-bordered": false,
      "content-bordered": true
    }
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "background-color": "#F7F7F7"
    }
  }, [_vm._l((_vm.titleList), function(item, key) {
    return _c('th', [_vm._v("\n        " + _vm._s(item.labelName) + "\n      ")])
  }), _vm._v(" "), _c('th', [_vm._v("\n        操作\n      ")])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.fileList), function(item, key) {
    return _c('tr', {
      key: key
    }, [_vm._l((_vm.labelIndex), function(indexItem, indexKey) {
      return _c('td', {
        key: indexKey
      }, [_vm._v("\n        " + _vm._s(item[indexItem]) + "\n      ")])
    }), _vm._v(" "), _c('td', [_c('x-button', {
      attrs: {
        "mini": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.showFile(key, _vm.fileList[key].savePath, _vm.fileList[key].fileType, _vm.fileList[key].fileId, item.fileName)
        }
      }
    }, [_vm._v("查看")]), _vm._v(" "), _c('img', {
      staticClass: "previewer-demo-img",
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "src": _vm.fileList[key].src,
        "width": "100"
      }
    })], 1)], 2)
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c61f2be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/DefaultFile.vue
// module id = cvPA
// module chunks = 0